import { Plugin } from "prosemirror-state";
import NotesTrackerElement from "./notes-tracker-element";

export const notesTrackerPlugin = new Plugin({
  view(editorView) {
    return new NotesTrackerElement(editorView);
  }
});